import { ca } from '@cian/analytics';
import { EDealType } from 'shared/repositories/cpd/entities/v1_create_cpd_draft/PublicV1CreateCpdDraftRequest';

export const trackFormOpen = (source: 'consultation' | 'ticket' | null) => {
  let label;

  if (source === 'consultation') {
    label = 'form_consultation';
  }

  if (source === 'ticket') {
    label = 'form_application';
  }

  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'open',
    label,
  });
};

export const trackFormClick = ({
  source,
  dealType,
  regionId,
  customSource,
}: {
  source: 'consultation' | 'ticket' | null;
  dealType: EDealType;
  regionId: number;
  customSource?: string;
}) => {
  let label;

  if (source === 'consultation') {
    label = 'form_consultation_call_me';
  }

  if (source === 'ticket') {
    label = 'form_application_call_me';
  }

  if (customSource === 'banner') {
    label = 'call_me';
  }

  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'click',
    label,
    page: {
      extra: {
        deal_type: dealType,
        region: regionId,
      },
    },
  });
};

export const trackFormSend = (draft_id: number, customSource?: string) => {
  let label = 'form_success_popup';

  if (customSource === 'banner') {
    label = 'banner_success_popup';
  }

  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'open',
    label,
    page: {
      extra: {
        draft_id,
      },
    },
  });
};
